import {
  DESCRIPTION_LABEL,
  DIMENSION_LABEL,
} from "../../../../../../../constants/Dictionary";
import {
  ManagementTable,
  ManagementTableHeader,
} from "../../../../../Components/Table/ManagementTable";
import { SoftSkillsDimensionConfigItem } from "../../../../../../../types/api/configurations.type";
import { FieldValues } from "react-hook-form";
import { compareDataGeneric } from "../../../../../../../utils/comparing.utils";
import {
  useManageSkillDimensions,
  useUpdateManageSkillDimensions,
} from "../../../../../../../hooks/management/CmSheet/SoftSkills/useManagementDimensions.hooks";

type ManageDimensionsProps = {
  toggleFilters: (x: boolean) => void;
  configYear: number;
};

export const ManageDimensions = ({
  toggleFilters,
  configYear,
}: ManageDimensionsProps) => {
  const { data, isFetching } = useManageSkillDimensions(configYear);
  const {
    mutate: updateManageSkillsDimensions,
    isPending: isUpdatingSkillsDimensions,
  } = useUpdateManageSkillDimensions();

  const dimensionsColumns: ManagementTableHeader[] = [
    {
      key: "name",
      label: DIMENSION_LABEL,
      width: 40,
      type: "text",
    },
    {
      key: "description",
      label: DESCRIPTION_LABEL,
      width: 60,
      type: "text",
    },
  ];

  const onSave = async (formData: FieldValues) => {
    const compareData = (formData.items as SoftSkillsDimensionConfigItem[]).map(
      (item, index) => ({
        ...item,
        position: index + 1,
      }),
    );

    const result = compareDataGeneric<SoftSkillsDimensionConfigItem>(
      data!,
      compareData,
    );
    updateManageSkillsDimensions(result);
  };

  return (
    <ManagementTable<SoftSkillsDimensionConfigItem>
      data={data ?? []}
      headers={dimensionsColumns}
      itemLabel={DIMENSION_LABEL}
      draggableRows={true}
      keyItem={"name"}
      toggleFilters={toggleFilters}
      onSave={onSave}
      loading={isFetching || isUpdatingSkillsDimensions}
    />
  );
};
